import api from './api';

export const authLogin = (email, password) =>
  api.post('/auth/login', { email, password });

export const authRegister = (email, password, name) =>
  api.post('/auth/register', { email, password, name });

export const authMe = (config) => api.get('/auth/me', config);

export const authVerifyEmail = (token) =>
  api.post('/auth/verify-email', { token });

export const authResendVerification = (email) =>
  api.post('/auth/resend-verification', { email });

export const authForgotPassword = (email) =>
  api.post('/auth/forgot-password', { email });

export const authResetPassword = (token, password) =>
  api.post('/auth/reset-password', { token, password });

export const authGoogleSession = (sessionId) =>
  api.post('/auth/google/session', { session_id: sessionId });

export const authUpdateMe = (updates) => api.patch('/auth/me', updates);

export const authGetNotificationPreferences = () =>
  api.get('/auth/me/notification-preferences');

export const authUpdateNotificationPreferences = (preferences) =>
  api.put('/auth/me/notification-preferences', preferences);
